import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { productsQueryOptions, selectStorefrontCatalog } from "@/lib/products";

/** The storefront catalogue, out of the same cached products query as the menu. */
export const useStorefrontCatalog = () =>
  useSuspenseQuery({
    ...productsQueryOptions(),
    select: selectStorefrontCatalog,
  });

/** The catalogue without suspending, for chrome such as the header cart. */
export const useStorefrontCatalogQuery = () =>
  useQuery({ ...productsQueryOptions(), select: selectStorefrontCatalog });
